export default function authHeader() {
  try {
    const user = localStorage.getItem('user')
    if (user) {
      return { 'x-access-token': user }
    } else {
      return {}
    }
  } catch (error) {
    console.error(error)
  }
}
